<template>
    <v-dialog-old ref="dialog" id="limitedDialog">
        <div class="promo-popup">
            <div class="promo-popup__data">
              <a href="#"  id="fileLink" />
                <div class="promo-popup__title">Выберите тариф</div>
                <div class="promo-popup__tarifs">

                    <div class="promo-popup__tarif">
                        <div class="promo-popup__tarif-title">
                            Пробный
                        </div>
                        <div class="promo-popup__tarif-price-items">
                            <div class="promo-popup__tarif-price-item">
                                <div class="promo-popup__tarif-price-item-label">
                                    за месяц
                                </div>
                                <div class="promo-popup__tarif-price-item-val">
                                    {{ formatPrice(trialPrice / 3) }} ₽
                                </div>
                            </div>
                            <div class="promo-popup__tarif-price-item">
                                <div class="promo-popup__tarif-price-item-label green">
                                    3 месяца
                                </div>
                                <div class="promo-popup__tarif-price-item-val bold">
                                    {{ formatPrice(trialPrice) }} ₽
                                </div>
                            </div>
                        </div>
                        <div class="promo-popup__tarif-actions">
                            <div @click="getInnerInvoice('probnij')" class="btn btn-light">
                                Получить счет
                            </div>
                            <div @click="getYookassaInvoice('probnij')" class="btn">
                                Оплатить картой
                            </div>
                        </div>
                    </div>

                    <div class="promo-popup__tarif primary">
                        <div class="promo-popup__tarif-title">
                            Выгодный
                        </div>
                        <div class="promo-popup__tarif-price-items">
                            <div class="promo-popup__tarif-price-item">
                                <div class="promo-popup__tarif-price-item-label">
                                    за месяц
                                </div>
                                <div class="promo-popup__tarif-price-item-val">
                                    {{ formatPrice(profitablePrice / 12) }} ₽ <div class="promo-popup__tarif-price-item-marker">-50%</div>
                                </div>
                            </div>
                            <div class="promo-popup__tarif-price-item">
                                <div class="promo-popup__tarif-price-item-label green">
                                    12 месяцев
                                </div>
                                <div class="promo-popup__tarif-price-item-val bold">
                                    {{ formatPrice(profitablePrice) }} ₽
                                </div>
                            </div>
                        </div>
                        <div class="promo-popup__tarif-actions">
                            <div @click="getInnerInvoice('vigodnij')" class="btn btn-light">
                                Получить счет
                            </div>
                            <div @click="getYookassaInvoice('vigodnij')" class="btn">
                                Оплатить картой
                            </div>
                        </div>
                    </div>
                </div>

                <div class="promo-popup__info">
                    Нажимая кнопки "Оплатить картой" или "Получить счет", вы принимаете
                    <a href="/net-contract"
                       target="_blank"
                       style="text-decoration: underline; border-bottom: 0;">оферту</a>.
                </div>
            </div>
        </div>
    </v-dialog-old>
</template>

<script>
import moment from 'moment';
import { formatPrice } from "@/global/helpers";
import {mapState} from "vuex";

export default {
    data() {
        return {
            trialPrice: 0,
            profitablePrice: 0,
            formatPrice: formatPrice
        };
    },
    methods: {
      getYookassaInvoice (tariffNameSlug, isRassrochka = false) {
        this.axios.post('/network/promo/yookassaPaymentHref', {
          tariffNameSlug: tariffNameSlug,
          returnPath: this.cleanPromoPath(window.location.pathname),
          isRassrochka: isRassrochka,
        }).then(response => {
            window.location.href= response.data;
        });
      },
        cleanPromoPath(path) {
            return '/'+path.split('/').filter(part => part && part !== 'promo').join('/');
        },
      getInnerInvoice (tariffNameSlug) {
          this.axios.get('/network/isAuthed?login=' + encodeURIComponent(this.currentUser.login)).then(response => {
              if (response.data.status === 'success') {
                  this.axios.post('/network/promo/invoice/'+tariffNameSlug,{},{
                      responseType: 'blob'
                  }).then(response => {
                      let dllink = document.getElementById('fileLink');
                      const myBlob = new Blob([response.data], {type : 'application/pdf'});
                      dllink.href = window.URL.createObjectURL(myBlob);
                      dllink.setAttribute("download",'Счет '+response.headers.filename +' от ' + moment().format("YYYY-MM-DD") + '.pdf'); // Added Line
                      dllink.click();

                  });
              } else if (response.data.status === 'unauthorized') {
                  this.$modal('Ошибка авторизации', {
                      name: 'Обновить страницу',
                      callback: () => window.location.reload()
                  }, {}, false, 'only-text-dialog');
              }
          });
      },
      show(trialPrice, profitablePrice) {
        this.trialPrice = trialPrice;
        this.profitablePrice = profitablePrice;
        this.$refs.dialog.show();
      },
    },
    computed: {
        ...mapState({
            currentUser: state => state.currentUser,
        }),
    }
}
</script>

<style>
dialog#limitedDialog {
    width: max-content;
    margin-left: auto;
    margin-right: auto;
}

#limitedDialog *,
#limitedDialog *::before,
#limitedDialog *::after {
    box-sizing: border-box;
    outline: none;
    margin: 0;
}

#limitedDialog ul,
#limitedDialog ol {
    padding: 0 0 0 0px;
}

#limitedDialog .promo-popup {
    width: 471px;
    padding: 19px;
    font-family: "Open Sans", sans-serif;
}

#limitedDialog .promo-popup__title {
    font-size: 35px;
    line-height: 120%;
    color: #13A546;
    font-weight: 600;
    margin-bottom: 30px;
}

#limitedDialog .promo-popup__tarifs {
    display: flex;
    gap: 16px;
    justify-content: space-between;
}

#limitedDialog .promo-popup__tarif {
    flex: 0 0 50%;
    padding: 24px 0;
    display: flex;
    flex-direction: column;
    gap: 16px;
    max-width: 155px;
}

#limitedDialog .promo-popup__tarif.primary {
    padding: 24px;
    background: #F3FAF6;
    border-radius: 24px;
    max-width: 215px;
}

#limitedDialog .promo-popup__tarif-title {
    font-size: 24px;
    color: #272727;
    text-transform: uppercase;
    font-weight: 700;
    line-height: 93%;
}

#limitedDialog .promo-popup__tarif-price-items {
    display: flex;
    flex-direction: column;
    gap: 16px;
}

#limitedDialog .promo-popup__tarif-price-item {
    display: flex;
    flex-direction: column;
    gap: 0px;
}

#limitedDialog .promo-popup__tarif-price-item-label {
    font-size: 14px;
    font-weight: 600;
    line-height: 100%;
    padding-top: 1px;
}

#limitedDialog .promo-popup__tarif-price-item-val {
    font-family: 'PT Sans', sans-serif;
    font-size: 24px;
    line-height: 120%;
    letter-spacing: -0.8px;
    display: flex;
    align-items: center;
    gap: 13px;
}

#limitedDialog .promo-popup__tarif-actions {
    margin-top: 9px;
    display: flex;
    flex-direction: column;
    gap: 16px;
}

#limitedDialog .promo-popup__tarif-price-item-marker {
    font-size: 13px;
    height: 23px;
    width: 52px;
    display: inline-flex;
    align-items: center;
    justify-content: center;
    color: #fff;
    background: #FD5A3E;
    border-radius: 5px;
    letter-spacing: initial;
    font-weight: 700;
}

#limitedDialog .promo-popup__info {
    margin-top: 32px;
    font-size: 12px;
    line-height: 120%;
    color: #9896AE;
    letter-spacing: -.64px;
}

#limitedDialog .promo-popup__info a {
    color: #2C2B67;
}

#limitedDialog .green {
    color: #009639;
}

#limitedDialog .bold {
    font-weight: 700;
}

#limitedDialog .btn {
    height: 31px;
    padding: 10px 10px 12px;
    color: #fff;
    background: #13A546;
    border-radius: 4px;
    display: flex;
    align-items: center;
    justify-content: center;
    font-weight: 600;
    font-size: 14px;
    line-height: 100%;
    cursor: pointer;
    transition: .5s ease;
}

#limitedDialog .btn:hover {
    color: #fff;
    background: #007B2B;
}

#limitedDialog .btn-light {
    border: 1px solid #13A546;
    color: #13A546;
    background: #fff;
}

#limitedDialog .btn-light:hover {
    background: #13A546;
}

@media (max-width: 991px) {}

@media (max-width: 600px) {}
</style>
